import { useRef, useState } from "react";
import { DivSearchFormBox, FormSearchForm, InputSearchForm } from "./style";
import { HistoryListItem } from "~/components/blocks/layout/global-navi/desktop/right/search-form/history-list-item";
import { useDesktopSearchForm } from "~/components/blocks/layout/global-navi/desktop/right/search-form/hooks/use-desktop-search-form";
import { useFade } from "~/hooks/use-fade";
import { G_ViewableRating } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

export const SearchForm = () => {
  const inputRef = useRef<HTMLLabelElement>(null);
  const historyListRef = useRef<HTMLDivElement>(null);
  const [isShowSearchHistory, setIsShowSearchHistory] = useState(false);
  const onVisibleHistoryList = () => setIsShowSearchHistory(true);
  const onHideHistoryList = () => setIsShowSearchHistory(false);
  const { isLoggedIn, viewableRating } = useAuth();

  const isViewableUnrestricted = !isLoggedIn || viewableRating === G_ViewableRating.R18;

  const {
    keyword,
    searchHistories,
    onChangeInputValue,
    onClickClearButton,
    onClickClearSearchHistory,
    onFocusSearchForm,
    onBlurSearchForm,
    onKeyDown,
    onMouseDownSuggestArea,
    pushToVideoList,
    onHoldOff,
  } = useDesktopSearchForm({
    inputRef,
    onVisibleHistoryList,
    onHideHistoryList,
  });

  const { isDisplay } = useFade(isShowSearchHistory, 150);

  return (
    <DivSearchFormBox>
      <FormSearchForm name="header_search">
        <InputSearchForm
          ref={inputRef}
          type="text"
          name="keyword"
          isCounterArea={false}
          value={keyword}
          placeholder="作品名・人名で検索"
          iconName="search"
          iconSize="M"
          iconColor="GRAY900"
          onChange={onChangeInputValue}
          onClickClearButton={onClickClearButton}
          onFocus={onFocusSearchForm}
          onBlur={onBlurSearchForm}
          onKeyDown={onKeyDown}
          maxLength={1000}
        />
      </FormSearchForm>

      {isDisplay && (
        <HistoryListItem
          historyListRef={historyListRef}
          inputRef={inputRef}
          isShowSearchHistory={isShowSearchHistory}
          searchHistories={searchHistories}
          isViewableUnrestricted={isViewableUnrestricted}
          onMouseDownSuggestArea={onMouseDownSuggestArea}
          pushToSearch={pushToVideoList}
          onClickClearSearchHistory={onClickClearSearchHistory}
          onHoldOff={onHoldOff}
        />
      )}
    </DivSearchFormBox>
  );
};
